import React, { Component } from 'react';
import moment from 'moment';
import styles from './card.less';

export default class Card extends Component {
  render() {
    const { title, outputDate, coverPicFileUrl } = this.props;
    return (
      <div className={styles.cardList}>
        <div className="img" style={{ backgroundImage: `url(${coverPicFileUrl})` }} />

        <div className="title-name">{title}</div>
        <div className="time">{moment(outputDate).format('YYYY.MM.DD')}</div>
      </div>
    );
  }
}
